var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('audio',{ref:"audioPlayer",attrs:{"src":_vm.audioSource,"autoplay":""},on:{"ended":_vm.onAudioEnded}})])
}
var staticRenderFns = []

export { render, staticRenderFns }